module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "singlePostYear"
  }, [(!_vm.singleLoaded) ? _c('div', {
    staticClass: "singleLoaded"
  }, [_c('h1', {
    staticClass: "headerElement"
  }, [_vm._v("Loading")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "signlePostHeader",
    style: ({
      'border-color': _vm.yearColor
    })
  }, [_c('span', {
    staticClass: "headerElement",
    style: ({
      color: _vm.yearColor
    }),
    attrs: {
      "id": "description"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "headerElement alignCenter",
    style: ({
      color: _vm.yearColor
    }),
    attrs: {
      "id": "year"
    }
  }, [_vm._v("Year"), _c('br', {
    staticClass: "tabletView"
  }), _vm._v(" " + _vm._s(_vm.year))]), _vm._v(" "), (_vm.showIndexFirst) ? _c('span', {
    staticClass: "headerElement alignRight",
    style: ({
      color: _vm.yearColor
    })
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Back")])]) : _c('span', {
    staticClass: "headerElement alignRight",
    style: ({
      color: _vm.yearColor
    })
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goBackNone()
      }
    }
  }, [_vm._v("Back")])])]), _vm._v(" "), _c('div', {
    staticClass: "postcontentWrapper"
  }, [_c('div', {
    staticClass: "postcontentWrapperInner"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "postcontentWrapperTitle"
  }, [_c('p', {
    staticClass: "splashTitle",
    style: ({
      color: _vm.yearColor,
      'border-color': _vm.yearColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.postJsonTitle)
    }
  })]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.postJsonContentMedia)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right",
    style: ({
      background: _vm.yearColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.postJsonContent)
    }
  })]), _vm._v(" "), (_vm.postJsonContentFullSize) ? _c('div', {
    staticClass: "postcontentFullSize",
    style: ({
      color: _vm.yearColor
    })
  }, [_c('div', {
    staticClass: "fullSizeContent"
  }, _vm._l((_vm.postJsonContentFullSize), function(img) {
    return _c('img', {
      style: ({
        'max-width': img.width / img.height < 1 ? '40%' : ''
      }),
      attrs: {
        "src": img.sizes.large
      }
    })
  }))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5903260a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/singlePostYear.vue
// module id = 58
// module chunks = 1